<template>
  <div class="Container">
    <h2>{{ $t('auth.confirm_forgot_password.sub_welcome') }}</h2>

    <vv-form-text-input
      label="password"
      id="password"
      type="password"
      :validate="'required'"
      v-model="password"
    />

    <vv-form-text-input
      label="confirmPassword"
      id="confirmPassword"
      type="password"
      :validate="'required'"
      v-model="confirmPassword"
    />

    <validate-form-button
      @click="updatePassword"
      :label="'forms.resetPasswordCta'"
      :isLoading="isLoading"
    />
  </div>
</template>

<script>
import { CONFIRM_RESET_PASSWORD } from '@/store/modules/user/types'
import VvFormTextInput from '@/components/common/forms/VvFormTextInput'
import ValidateFormButton from '@/components/common/ValidateFormButton'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'

export default {
  name: 'ConfirmResetPassword',
  components: { VvFormTextInput, ValidateFormButton },
  data: () => ({
    password: '',
    confirmPassword: '',
    isLoading: false,
    success: false
  }),
  methods: {
    async updatePassword() {
      this.$validator.validateAll().then(async result => {
        if (!result) {
          return
        }

        const code = this.$route.query.code

        if (this.password !== this.confirmPassword) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/password-mismatch') })
          return
        }

        if (!this.password.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*/) || this.password.length < 8) {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/weak_password') })
          return
        }

        this.isLoading = true

        const [error, response] = await this.$store.dispatch(CONFIRM_RESET_PASSWORD, {
          code,
          password: this.password,
          confirmPassword: this.confirmPassword
        })

        if (error || response.data.error) {
          this.success = false
          if (error && error.code) {
            this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code)})
          } else {
            if (response.data.error) {
              this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + response.data.reason)})
            } else {
              this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/internal-error')})
            }
          }

          this.isLoading = false
        } else {
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('success.newPasswordConfirmed')})
          this.$router.push({ name: 'login' })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.Container {
  display: block;
  margin-left: 25px;
  width: calc(100% - 50px);
  margin-right: 25px;
}
</style>
